module.exports = __webpack_public_path__ + "img/pball-active.c6c486fe.svg";